import { useCallback, useState } from 'react'

export type ToggleState = [
	/** Current value of the toggle state */
	toggle: boolean,
	/** Toggle the current state. */
	onToggle: () => void,
	/** Set the toggle to `true` */
	on: () => void,
	/** Set the toggle to `false` */
	off: () => void,
]

/**
 * Like {@link useState}, but provides a convenient way to handle toggles.
 *
 * @param initialState the initial state of the toggle. Defaults to `false`.
 * @returns `[isToggled, toggle, on, off]`
 */
export const useToggle = (initialState = false): ToggleState => {
	const [toggle, setToggle] = useState(initialState)

	const onToggle = useCallback(() => setToggle(prev => !prev), [])
	const on = useCallback(() => setToggle(true), [])
	const off = useCallback(() => setToggle(false), [])

	return [toggle, onToggle, on, off]
}
